import { createFileRoute } from '@tanstack/react-router';
import { SupplierTable } from '@/components/Pages/Suppliers/SupplierTable';
import { CreateEditSupplierModal } from '@/components/Pages/Suppliers/CreateEditSupplierModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/suppliers/')({
  component: SuppliersPage,
});

function SuppliersPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditSupplierModal />
        </Box>
      )}
      <SupplierTable />
    </Box>
  );
}
